<template>
  <table class="listado table table-hover">
    <thead class="bg-primary text-white">
      <th-ordenado titulo="Nombre" campo="nombre" />
      <th-ordenado class="text-center" titulo="Saas forzado" campo="forzarProyectoSaas" />
      <th class="th-acciones">Acciones</th>
    </thead>
    <tbody>
      <tr v-for="campania in campanias" :key="campania.id" role="button">
        <td @click="editarCampania(campania.id)">
          {{ campania.nombre }}
        </td>
        <td class="text-center" @click="editarCampania(campania.id)">
          {{ sino(campania.forzarProyectoSaas) }}
        </td>
        <td nowrap="nowrap" class="td-acciones-auto">
          <b-button-group size="sm">
            <b-button variant="primary" class="actionButton" :to="`/campanias/editar/${campania.id}`">
              <v-icon variant="primary" name="edit" width="16" /><span>Editar</span>
            </b-button>
            <boton-eliminar @ok="$emit('eliminar', campania.id)">
              ¿ Desea eliminar la campaña <b>{{ campania.nombre }}</b> ?
            </boton-eliminar>
          </b-button-group>
        </td>
      </tr>
    </tbody>
    <tfoot v-if="!campanias.length">
      <sin-registros :colspan="4" />
    </tfoot>
  </table>
</template>
<script>
export default {
  props: {
    campanias: Array,
  },
  methods: {
    sino: (x) => (x ? "Sí" : "No"),
    editarCampania(campaniaId) {
      this.$router.push("/campanias/editar/" + campaniaId);
    },
  },
};
</script>
